// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__Aeqwu","btnDefault":"style_btnDefault__fq0C_"};